import { Box, Stack, Typography, TypographyVariant } from '@mui/material';

interface Data {
    quantity: number;
    background: string;
    textVariant: TypographyVariant;
    iconSize?: number;
}

const ScoreData = (props: Data) => {
    const size = props.iconSize ?? 36;

    return (
        <Stack
            direction="row"
            spacing={0.5}
            sx={{
                alignItems: 'center',
                color: 'white',
            }}
        >
            <Box
                sx={{
                    width: size,
                    height: size,
                    flexShrink: 0,
                    backgroundImage: props.background,
                    backgroundSize: 'contain',
                    backgroundPosition: 'center',
                    backgroundRepeat: 'no-repeat',
                }}
            />
            <Typography
                variant={props.textVariant}
                sx={{ whiteSpace: 'nowrap', lineHeight: 1 }}
            >
                {`x${props.quantity}`}
            </Typography>
        </Stack>
    );
};

export default ScoreData;
